import React, { useState } from "react"
import { Link } from "gatsby"

import { Text } from "../../Text/Text"


interface OwnProps {
  footerLinks: { name: string, url: string }[]
  title: string
}

type FooterLinksProps = OwnProps

export const FooterLinks: React.FC<FooterLinksProps> = ({
  footerLinks,
  title
}) => {
  const [isActive, setIsActive] = useState(false);

  const footerLinkToggle = (): void => {
    setIsActive(!isActive)
  }
  
  return (
    <div className={`${isActive ? "expanded" : ""}`} onClick={footerLinkToggle}>
      <h2 className="relative after:absolute after:content-['+'] after:font-medium after:right-0 [.expanded_&]:after:rotate-45 after:md:hidden">
        <Text as="span" variant="small-subheader">{title}</Text>
      </h2>
      <ul>
        {footerLinks?.map((item, index) => {
          return (
            <li className="hidden mt-2.5 first:5 md:block [.expanded_&]:block" key={index}>
              <Link to={item.url}>
                <Text as="span" variant="body-caps">{item.name}</Text>
              </Link>
            </li>
          )
        })}   
      </ul>
    </div>
  )
}
